import { readJson, writeJson } from './storage';

export type ThemePreference = 'system' | 'light' | 'dark';

export function getThemePreference(): ThemePreference {
  const v = readJson<ThemePreference>(null, 'theme');
  return v === 'light' || v === 'dark' ? v : 'system';
}

/** Tema tercihini kök öğeye uygular ve durum çubuğu rengini günceller. */
export function applyThemePreference(pref: ThemePreference = getThemePreference()): void {
  const root = document.documentElement;
  if (pref === 'system') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', pref);
  const dark = pref === 'dark' || (pref === 'system' && window.matchMedia?.('(prefers-color-scheme: dark)').matches);
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', dark ? '#06110d' : '#063B2D');
}

export function setThemePreference(pref: ThemePreference): void {
  writeJson(null, 'theme', pref === 'system' ? null : pref);
  applyThemePreference(pref);
}
